import { render, staticRenderFns } from "./AllTransectionLazada.vue?vue&type=template&id=1624d9cb&scoped=true&"
import script from "./AllTransectionLazada.vue?vue&type=script&lang=js&"
export * from "./AllTransectionLazada.vue?vue&type=script&lang=js&"
import style0 from "./AllTransectionLazada.vue?vue&type=style&index=0&id=1624d9cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1624d9cb",
  null
  
)

export default component.exports